import { useCallback } from 'react'

import { apiUrl, toQuery, useApiRequest } from '../useApiRequest'

import { PurchasedPass } from '../../types/booking/booking'

export function usePurchasedPasses() {
  const { run, loading, error, resetState } = useApiRequest()

  const mine = useCallback(
    (includeInactive = false) =>
      run(({ fetcher }) =>
        fetcher<PurchasedPass[]>(apiUrl(`/purchased-passes${toQuery({ includeInactive })}`))
      ),
    [run]
  )

  const ofProfile = useCallback(
    (profileId: string | number, includeInactive = false) =>
      run(({ fetcher }) =>
        fetcher<PurchasedPass[]>(
          apiUrl(`/profiles/${profileId}/purchased-passes${toQuery({ includeInactive })}`)
        )
      ),
    [run]
  )

  return { mine, ofProfile, loading, error, resetState }
}
